import { render, staticRenderFns } from "./MyApplications.vue?vue&type=template&id=6899a5e1&"
import script from "./MyApplications.vue?vue&type=script&lang=js&"
export * from "./MyApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports